import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";

const ServerSearchInput = ({ onChange, fullWidth = false }) => {
  const { t } = useTranslation();

  return (
    <TextField
      size="small"
      variant="outlined"
      placeholder={t("common.search")}
      onChange={(e) => onChange?.(e.target.value)}
      fullWidth={fullWidth} // 👈 thêm dòng này
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "#D0D5DD" }} />
          </InputAdornment>
        ),
      }}
      sx={{
        width: fullWidth ? "100%" : "auto", // 👈 optional (để chắc chắn)
        "& .MuiInputBase-root": {
          borderRadius: "8px",
          backgroundColor: "#FEFEFE",
          minHeight: "40px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD",
          borderWidth: "1px",
        },
        // Bỏ hiệu ứng hover/focus
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD !important",
          borderWidth: "1px !important",
        },
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD !important",
          borderWidth: "1px !important",
        },
        "& .MuiOutlinedInput-root.Mui-focused": {
          boxShadow: "none",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD !important",
          borderWidth: "1px !important",
        },
        "& .MuiInputBase-input": {
          outline: "none",
          "&:focus, &:focus-visible": {
            outline: "none",
          },
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#000000",
        },
      }}
    />
  );
};

export default ServerSearchInput;
